<template>
	<v-card>
		<v-card-title>
			<h3 class="headline font-weight-bold">{{getObjectValue('name', role)}}</h3>
		</v-card-title>

		<v-list v-if="permissions">
			<v-list-tile v-for="permission in PERMISSIONS" :key="permission.id">
				<v-list-tile-content>
					<v-checkbox v-model="permissions" :label="permission.name" :value="permission.name"></v-checkbox>
				</v-list-tile-content>
			</v-list-tile>
		</v-list>

		<v-card-actions class="pa-3">
			<v-spacer></v-spacer>
			<v-btn color="primary" @click="save">Save Permissions</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			permissions: []
		};
	},

	props: {
		slug: {
			default: null
		}
	},

	computed: {
		...mapGetters("admin", {
			SELECTED_ROLE: "selectedRole",
			PERMISSIONS: "permissions"
		}),

		role() {
			return this.SELECTED_ROLE(this.slug);
		},

		previousPermissions() {
			return _.map(
				this.getObjectValue("permissions", this.role),
				perm => perm.name
			);
		}
	},

	methods: {
		...mapActions("admin", {
			GET_PERMISSIONS: "getPermissions",
			POST_ROLE_PERMISSIONS: "postRolePermissions"
		}),

		save() {
			this.POST_ROLE_PERMISSIONS({
				id: this.role.id,
				data: this.permissions
			});
		}
	},

	created() {
		if (!this.PERMISSIONS.length) {
			this.GET_PERMISSIONS();
		}

		this.$set(this, "permissions", this.previousPermissions);
	},

	watch: {
		role() {
			this.$set(this, "permissions", this.previousPermissions);
		}
	}
};
</script>
